/**
 * Matérialisation typée des contrats de ports.
 * La spécification fait foi : runward/contracts/*.md. Ce fichier la traduit en types,
 * partagés par le serveur et l'interface — un seul endroit où le contrat existe.
 *
 * Règle d'évolution (ADR-0004, contracts-governance) : versionné, additif par défaut,
 * lecteur tolérant, expand-then-contract sur toute rupture.
 */
export const CONTRACTS_VERSION = "0.1.0";
/** Familles métier. Valeur close : une catégorie source non mappée est écartée, jamais devinée. */
export const FAMILLES = ["stand", "publicite", "repas", "formation", "acces_visiteur"];
/** Rôles portés par un rattachement (compte × édition), jamais par le compte seul. */
export const ROLES = [
    "exposant", "stagiaire", "intervenant", "conferencier",
    "organisateur", "invite", "visiteur", "gestionnaire_visiteurs", "administrateur",
];
// ---------- Réservation — colonne vertébrale du plancher (ADR-0002) ----------
/**
 * État de cycle de vie d'une réservation. Valeur close.
 * `brouillon` : l'exposant compose son stand et ses options ; rien n'est figé.
 * `validee`   : l'acte métier est acquis, les prix sont gelés, la clé d'idempotence dérivée.
 * `annulee`   : réservation retirée ; conservée pour la trace, jamais supprimée.
 */
export const ETATS_RESERVATION = ["brouillon", "validee", "annulee"];
// ---------- Entités de gestion (CRUD générique) ----------
/**
 * Les entités de saisie du back-office. Contrairement à la Réservation (domaine riche : argent,
 * idempotence), ce sont des fiches de données : personnes, ateliers, salons, référentiels.
 * Elles partagent un CRUD générique ; leurs champs vivent dans `donnees` (JSONB).
 */
export const TYPES_ENTITE = [
    "exposant", "stagiaire", "intervenant", "conferencier", "organisateur",
    "visiteur", "invite", "atelier", "inscription", "salon", "etablissement",
    "lead", "question", "presence", "scan_stand",
];
// Écran salon : croquis 2026 uniquement, visiteurs pseudonymes et horloge serveur.
export const EDITION_PLAN_SALON = 11;
export const DUREE_SCAN_SALON_MS = 120_000;
//# sourceMappingURL=index.js.map